import React, { Component } from 'react'

import {
  Collapse,
  Input,
  FormGroup,
} from "xsolla-uikit";


export default class PACollapse extends Component {

  constructor(props) {
    super(props)
    this.label = this.props.label || '';
    this.localesList = this.props.localeList || ['English', 'Russian', 'French'];
    this.content = this.props.content || [];
    this.state = {
      content: this.props.content || [],

    }

    this.setValueGeneralName = (e: SyntheticInputEvent<HTMLInputElement>) => {
      let newContent = [...this.state.content]
      let value = e.target.value;
      newContent[0] = value;
      this.setState({
        content: [...newContent]
      })
      let timestamp = new Date().getTime().toString().substring(0,7);
      let sku = value.replace(/\s+/g, '_').toLowerCase();
      // let sku = `${value.replace(/\s+/g, '_').toLowerCase()}_${this.props.keyId}`;
      // let sku = `${value.replace(/\s+/g, '_')}_${this.props.keyId}`
      // let sku = `${this.props.keyId}`
      this.props.setValueGeneralName(value, sku)
    }
  }



  // bigText = `Portal™ is a new single player game from Valve. Set in the mysterious Aperture
  // Science Laboratories, Portal has been called one of the most innovative new games on the horizon
  // and will offer gamers hours of unique gameplay. The game is designed to change the way players
  // approach, manipulate, and surmise the possibilities in a given environment; similar to how
  // Half-Life® 2's Gravity Gun innovated new ways to leverage an object in any given situation.
  // Players must solve physical puzzles and challenges by opening portals to maneuvering objects,
  // and themselves, through space.`;



  render() {
    return (
      <div>


              <Collapse
                isOpened={false}
                staticElements={1}
                collapsedLabel={count => `${count} more languages`}
                expandedLabel={() => 'Hide localizations'}>
                {this.localesList.map((locale, index) => (
                  <FormGroup
                    key={index}
                    label={`${this.props.label} | ${locale}`}
                    indentation="sm"
                    // tooltip={'Project name'}
                  >
                    <Input
                      key={index}
                      // focused= {(!index) ?  true : false}
                      input={{
                        name: `name.${locale}`,
                        value: this.state.content[index] || '',
                        onChange: this.setValueGeneralName
                      }} />
                  </FormGroup>
                ))}
              </Collapse>


              {/* <Collapse
                btnIconPosition="end"
                staticElements={1}
                showElementsInline={true}
                collapsedLabel={() => 'Show more'}
                expandedLabel={() => 'Collapse'}>
                {[
                  <span key={0}>{this.bigText.substr(0, 200)}</span>,
                  <span key={1}>{this.bigText.substr(200)}</span>
                ]}
              </Collapse> */}


      </div>
    )
  }
}
